import { Text as RadixText, type TextProps as RadixTextProps } from '@radix-ui/themes';
import { cn } from '@/lib/utils';
import { RadixTextSize } from './RadixProps';

type OverrideSize<T> = Omit<T, 'size'> & {
  size?: '0.5' | RadixTextSize;
};

type WithHalfSize<T> = T extends unknown ? OverrideSize<T> : never;

type TextProps = WithHalfSize<RadixTextProps>;

export function Text<TAs extends 'span' | 'div' | 'label' | 'p' = 'span'>({
  className,
  size = '1',
  ...props
}: Extract<TextProps, { as?: TAs }>) {
  const isHalf = size === '0.5';
  return (
    <RadixText
      size={isHalf ? '1' : size}
      className={cn(isHalf && 'text-0-5', className)}
      {...props}
    />
  );
}

export type { TextProps };
